<script lang="ts">
    import { mdiStar } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import ProductPricetags from "./widgets/ProductPricetags.svelte"

    export let product: BKDFProduct,
        productTitleAsHeading: boolean = false
</script>

<section class="productDetails1">
    {#if productTitleAsHeading}
        <h1>{product.title}</h1>
    {:else}
        <em>{product.title}</em>
    {/if}
</section>
<section class="productDetails2">
    <ProductPricetags product="{product}" />
    <div class="avgRating">
        <Icon
            path="{mdiStar}"
            size="0.8"
        />4.5
    </div>
</section>

<style lang="less">
    .productDetails1 {
        margin-top: 1.2rem;
        em,
        h1 {
            color: var(--text-invers-100);
            font-size: 1.2rem;
            font-weight: 700;
            font-style: normal;
            font-style: Outfit;
        }
    }
    .productDetails2 {
        margin-top: 1.2rem;
        display: flex;
        justify-content: space-between;

        .avgRating {
            display: flex;
            align-items: center;
            gap: 0.3rem;
            color: var(--text-invers-100);
            font-size: 1rem;
            font-weight: 700;
            font-style: normal;
            font-family: Outfit-Bold, sans-serif;
        }
    }
</style>
